import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createRoot, Root } from 'react-dom/client';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Provider } from 'react-redux';
import { StrictMode } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import './styles.scss';
import globalTheme from '@styles/theme/global-theme';
import store from '@core/store/store';
import {
  AppInsightsContext,
  AppInsightsErrorBoundary,
  ReactPlugin,
} from '@microsoft/applicationinsights-react-js';
import { setAppRoutes } from '@app/Routes';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { GlobalLoader } from '@app/shared/layout/global-loader/GlobalLoader';
import api from '@server/api-config';
import registerApiInterceptor from '@server/register-api-interceptor';

const reactPlugin = new ReactPlugin();
const root: Root = createRoot(document.getElementById('root')!);

// In axios 0.x,  handlers was a public property which could be checked to see if any interceptors had been registered,
// meaning we didn't need to worry about tracking it ourselves to avoid duplicate registration.
// This has been changed and since v1.13.3 it's no longer public so we're relying on this internal implementation detail.
// This could break if axios changes how interceptor registration works if we need to register other interceptors instead
// of using the one big interceptor we currently use.
if (!api.interceptors.response.handlers?.length && !api.interceptors.request.handlers?.length) {
  registerApiInterceptor(api);
}

const router = createBrowserRouter(setAppRoutes());

root.render(
  <StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <AppInsightsErrorBoundary appInsights={reactPlugin} onError={(<></>) as any}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={globalTheme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Provider store={store}>
                <GlobalLoader />
                <DndProvider backend={HTML5Backend}>
                  <RouterProvider router={router} />
                </DndProvider>
              </Provider>
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </AppInsightsErrorBoundary>
    </AppInsightsContext.Provider>
  </StrictMode>
);
